import React from "react";
import TabTemplate from "../../../_shoru_shared_library/template/TabTemplate";
import clashesTabRouter from "./clashesTabRouter";

function ClashesTab(props) {

  return (
    <TabTemplate 
      router={clashesTabRouter}
      passData={props.passData}
    />
  )

}

export default ClashesTab;